<template>
  <div>
    <div class="navBar">
      <div class="contentLogoAndTitle">
        <div>
          <img
            style="width: 150px; height: 80px; margin-top: 0.5rem"
            :src="logoBms"
          />
        </div>

        <div class="nameCompany" v-if="!handleVerifyUserIsAccountant">
          Olá, <span>{{ dataCompany.nome }}!</span>
        </div>
        <div
          class="nameCompanyCompanies"
          v-if="
            companies && companies.length > 0 && handleVerifyUserCorporation()
          "
        >
          <InputSelect
            :enableIconCreate="false"
            :items="companies"
            valueField="token"
            textField="nameCompany"
            :dataSelect.sync="tokenCompanySelected"
            @selectedIten="handleCompanySelected"
            ref="companies"
          />
        </div>
      </div>

      <div class="contentHelpAndNotificationAccounting">
        <router-link to="/pdv">
          <div class="contentNotificationAccounting">
            <p style="width: 100px">
              <img
                width="15"
                style="margin-right: 10px"
                :src="pdv2"
                alt=""
                srcset=""
              />
              PDV
            </p>
          </div>
        </router-link>
        <div
          class="contentHelp"
          @click="sideOpenAdnFindUser"
          v-if="!handleVerifyUserIsAccountant"
        >
          <b-icon-list
            variant="dark"
            scale="1.5"
            @click.stop="sideOpenAdnFindUser"
            class="iconHelper buttonToOpenSideCommon"
          />
        </div>
      </div>
      <div :class="`${sideOCompany} sideCommon`">
        <button class="closeSize" @click="sideOpenCompany">
          <b-icon-x-circle />
        </button>
        <div :class="`${contentSideOCompany} headerSide`">
          <img class="logoSide" :src="`${dataCompany.urlImage}`" alt="" />
          <div class="userContent">
            <p>Olá</p>
            <p>, {{ this.user.userName || dataCompany.nome }}</p>
            <!-- <div v-if="spinGeneral" class="card_content">
              , <b-spinner small class="spin"></b-spinner>
            </div> -->
          </div>
          <p style="font-size: 14px">{{ dataCompany.cpfcnpj }}</p>
        </div>
        <div :class="`${contentSideOCompany} contentSide`">
          <button
            v-b-modal.modalPlan
            @click="findPlan()"
            class="contentSideBtn contentBtnMyPlan"
          >
            Meu plano
            <span class="warningExpiredPlanToModal" v-if="!dataPlan.ativo">
              <b-icon-exclamation-circle-fill
                scale="1.3"
                style="color: red; background-color: white; border-radius: 50%"
              />
            </span>
          </button>
          <button class="contentSideBtn" @click="openContract">
            Detalhes do Contrato
          </button>
          <button class="contentSideBtn" @click="redirectWhatsApp">
            <b-icon-headset scale="1.5" class="mr-2" />Suporte
          </button>
        </div>
      </div>
    </div>

    <div
      :class="`sidebar ${disable}`"
      @mouseenter="sidBarExpand"
      @mouseleave="sidBarExpand"
    >
      <ul class="nav-links">
        <li>
          <router-link to="/home">
            <button
              style="margin-top: 10px"
              id="selected"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'home' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <img
                  class="teach"
                  style="height: 30px; width: 30px"
                  :src="faarm"
              /></i>
              <span :class="sizeText">Início</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/compendio">
            <button
              style="margin-top: 10px"
              id="selected"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'compendio' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <img
                  class="teach"
                  style="height: 30px; width: 30px"
                  :src="leaf"
              /></i>
              <span :class="sizeText">Compêndio</span>
            </button>
          </router-link>
        </li>
        <!-- <li style="height: auto" @click="redirectToConsultations">
          <label
            for="inputConsultations"
            :class="`${iconsCenter} contentLink `"
            style="
              background-color: transparent;
              height: auto;
              min-height: 40px;
              padding: 5px;
              cursor: pointer;
            "
          >
            <i
              :class="`${
                navItemSelected === 'consultas'
                  ? 'activeConsultationsNavItems'
                  : ''
              }`"
            >
              <img class="teach" style="height: 35px; width: 35px" :src="leaf"
            /></i>
            <span :class="sizeText">Compêndio</span>
          </label>
          <input
            type="checkbox"
            name="consultations"
            id="inputConsultations"
            :checked="consultationIsChecked"
          />

          <ul :class="`nav-links ulConsultation`">
            <li>
              <router-link to="/consultas">
                <button
                  style="padding-left: 60px; background-color: transparent"
                  :class="`${iconsCenter} contentLink linkAgrot`"
                >
                  <span :class="sizeText">Agrotoxicos</span>
                </button>
              </router-link>
            </li>
            <li>
              <router-link to="/consultas">
                <button
                  style="padding-left: 60px"
                  :class="`${iconsCenter} contentLink linkAgrot`"
                >
                  <span :class="sizeText">Culturas</span>
                </button>
              </router-link>
            </li>
          </ul>
        </li> -->
        <!-- <li>
          <router-link to="/receita">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'receita' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-journal-text scale="1.3"></b-icon-journal-text></i>
              <span :class="sizeText">Receituário Agronômico</span>
              <i style="visibility: hidden">
                <img class="teach" :src="exclusive"
              /></i>
            </button>
          </router-link>
        </li> -->

        <li style="height: auto">
          <button
            @click.stop="expandOrder = !expandOrder"
            style="height: 40px"
            :class="`${iconsCenter} contentLink ${
               navItemSelected === 'receita' ||
               navItemSelected === 'vendas-simples' ||
              navItemSelected === 'vendas'
                ? 'activeNavItems'
                : ''
            }`"
          >
            <div style="display: flex; width: 100%">
              <i> <b-icon-file-text scale="1.3"></b-icon-file-text></i>
              <span :class="sizeText">Ações</span>
            </div>

            <i
              v-if="!disable"
              :style="`transition: ease-in all 0.1s; ${
                expandOrder
                  ? 'transform: rotate(0) !important;'
                  : 'transform: rotate(-180deg) !important;'
              }`"
              ><b-icon-chevron-down
            /></i>
          </button>

          <ul
            :style="`
                border-left: solid 1px #6d6d6d;
                margin-left: 2rem;
                padding: 0.2rem 1.3rem;
                ${
                  !disable && expandOrder ? 'display: block;' : 'display: none;'
                }
              `"
          >
            <li style="height: 36px">
              <router-link to="/receita">
                <button
                  style="border-radius: 0"
                  :class="`${iconsCenter} contentLink prescription ${
                    navItemSelected === 'receita' ? 'activeSubNavItems' : ''
                  }`"
                >
                  <span :class="sizeText">Receituário Agronômico</span>
                </button>
              </router-link>
            </li>

            <li
              style="height: 36px; margin-top: 0.1rem"
              :class="!winfitComleto ? 'disabledLink' : ''"
            >
              <router-link :to="winfitComleto ? '/vendas-simples' : ''">
                <button
                  :class="`${iconsCenter} contentLink prescription ${
                    navItemSelected === 'vendas-simples'
                      ? 'activeSubNavItems'
                      : ''
                  }`"
                >
                  <span :class="sizeText">Venda Simples</span>
                </button>
              </router-link>
            </li>

            <li
              style="height: 36px; margin-top: 0.1rem"
              :class="!winfitComleto ? 'disabledLink' : ''"
            >
              <router-link :to="winfitComleto ? '/vendas' : ''">
                <button
                  :class="`${iconsCenter} contentLink prescription ${
                    navItemSelected === 'vendas' ? 'activeSubNavItems' : ''
                  }`"
                >
                  <span :class="sizeText">Venda Completa</span>
                </button>
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <router-link to="/cadastros">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'cadastros' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <b-icon-person-lines-fill scale="1.3"></b-icon-person-lines-fill
              ></i>
              <span :class="sizeText">Cadastros</span>
            </button>
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/vendas-simples">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'vendas-simples' ? 'activeNavItems' : ''
              }`"
            >
              <i><img class="teach" :src="sales" /></i>
              <span :class="sizeText">Pedido Simples</span>
              <i> <img class="teach" :src="exclusive" /></i>
            </button>
          </router-link>
        </li> -->

        <!-- <li>
          <router-link to="/vendas">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'vendas' ? 'activeNavItems' : ''
              }`"
            >
              <i><img class="teach" :src="sales" /></i>
              <span :class="sizeText">Pedido Completo</span>
              <i> <img class="teach" :src="exclusive" /></i>
            </button>
          </router-link>
        </li> -->
        <li :class="!winfitComleto ? 'disabledLink' : ''">
          <router-link :to="winfitComleto ? '/compras' : ''">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'compras' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-cart4 scale="1.3"></b-icon-cart4></i>
              <span :class="sizeText">Compras</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/inventario">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'inventario' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <b-icon-file-earmark-diff scale="1.3"></b-icon-file-earmark-diff
              ></i>
              <span :class="sizeText">Controle de Estoque</span>
            </button>
          </router-link>
        </li>

        <!-- <li>
          <router-link to="/estoque">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'estoque' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-box-seam scale="1.3"></b-icon-box-seam></i>
              <span :class="sizeText">Estoque Geral</span>
            </button>
          </router-link>
        </li> -->

        <li style="height: auto">
          <button
            @click.stop="expandFinancialManagement = !expandFinancialManagement"
            style="height: 40px"
            :class="`${iconsCenter} contentLink ${
              ['financeiro', 'boleto', 'cheques'].includes(navItemSelected)
                ? 'activeNavItems'
                : ''
            }`"
          >
            <div style="display: flex; width: 100%">
              <i><b-icon-cash-stack scale="1.3" /></i>
              <span :class="sizeText">Gestão Financeira</span>
            </div>

            <i
              v-if="!disable"
              :style="`transition: ease-in all 0.1s; ${
                expandFinancialManagement
                  ? 'transform: rotate(0) !important;'
                  : 'transform: rotate(-180deg) !important;'
              }`"
              ><b-icon-chevron-down
            /></i>
          </button>

          <ul
            :style="`
                border-left: solid 1px #6d6d6d;
                margin-left: 2rem;
                padding: 0.2rem 1.3rem;
                ${
                  !disable && expandFinancialManagement
                    ? 'display: block;'
                    : 'display: none;'
                }
              `"
          >
            <li
              style="height: 36px"
              :class="!winfitComleto ? 'disabledLink' : ''"
            >
              <router-link :to="winfitComleto ? '/financeiro' : ''">
                <button
                  style="border-radius: 0"
                  :class="`${iconsCenter} contentLink prescription ${
                    navItemSelected === 'financeiro'
                      ? 'activeSubNavItems'
                      : ''
                  }`"
                >
                  <span :class="sizeText">Financeiro</span>
                </button>
              </router-link>
            </li>

            <li
              style="height: 36px; margin-top: 0.1rem"
              :class="!winfitComleto || !allowsBoleto ? 'disabledLink' : ''"
            >
              <router-link :to="winfitComleto && allowsBoleto ? '/boleto' : ''">
                <button
                  style="border-radius: 0"
                  :class="`${iconsCenter} contentLink prescription ${
                    navItemSelected === 'boleto' ? 'activeSubNavItems' : ''
                  }`"
                >
                  <span :class="sizeText">Boletos</span>
                </button>
              </router-link>
            </li>

            <li
              style="height: 36px; margin-top: 0.1rem"
              :class="!winfitCompletePlan ? 'disabledLink' : ''"
            >
              <router-link :to="winfitCompletePlan ? '/cheques' : ''">
                <button
                  style="border-radius: 0"
                  :class="`${iconsCenter} contentLink prescription ${
                    navItemSelected === 'cheques' ? 'activeSubNavItems' : ''
                  }`"
                >
                  <span :class="sizeText">Cheques</span>
                </button>
              </router-link>
            </li>
          </ul>
        </li>

        <li :class="!winfitComleto ? 'disabledLink' : ''">
          <router-link :to="winfitComleto ? '/fiscal' : ''">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'fiscal' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <b-icon-file-earmark-text scale="1.3"></b-icon-file-earmark-text
              ></i>
              <span :class="sizeText">Emissão Fiscal</span>
            </button>
          </router-link>
        </li>

        <li :class="!winfitComleto ? 'disabledLink' : ''">
          <router-link :to="winfitComleto ? '/caixa' : ''">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'caixa' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-wallet scale="1.3"></b-icon-wallet></i>
              <span :class="sizeText">Caixa</span>
            </button>
          </router-link>
        </li>

        <li>
          <router-link to="/relatorios">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'relatorios' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-printer scale="1.3"></b-icon-printer></i>
              <span :class="sizeText">Relatórios</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/configuracoes">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'configuracoes' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="gear" /></i>
              <span :class="sizeText">Configurações</span>
            </button>
          </router-link>
        </li>
      </ul>

      <div class="containerBtnSair">
        <ul class="nav-links">
          <li>
            <router-link to="/">
              <button @click="exit" :class="`${iconsCenter} contentLink`">
                <i> <b-icon-door-open scale="1.3"></b-icon-door-open></i>
                <span :class="btnSair">Sair</span>
              </button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <b-modal
      id="modalPlan"
      size="lg"
      hide-footer
      hide-header
      centered
      title="Plan"
    >
      <button class="closeModal" @click="$bvModal.hide('modalPlan')">
        <b-icon-x scale="1.5"></b-icon-x>
      </button>
      <div class="planModalContainer">
        <!-- Cartão Principal -->
        <div class="planCardMain">
          <div class="planLogoRow">
            <img class="winfitLogo" :src="winfitLogoAgro" alt="Winfit Agro+" />
          </div>

          <!-- Conteúdo do Card -->
          <div class="planCardContent">
            <!-- Dados do Cliente -->
            <div class="planDataSection">
              <h3 class="planDataTitle">Dados do Cliente</h3>
              <div class="planDataItems">
                <div class="planDataItem">
                  <span class="planDataLabel">Usuário:</span>
                  <span class="planDataValue">{{ dataCompany.nome }}</span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">CNPJ/CPF:</span>
                  <span class="planDataValue">{{ dataCompany.cpfcnpj }}</span>
                </div>
                <div v-if="dataCompany.email" class="planDataItem">
                  <span class="planDataLabel">E-mail:</span>
                  <span class="planDataValue">{{ dataCompany.email }}</span>
                </div>
                <div v-if="dataCompany.telefone" class="planDataItem">
                  <span class="planDataLabel">Contato:</span>
                  <span class="planDataValue">{{ dataCompany.telefone }}</span>
                </div>
              </div>
            </div>

            <!-- Divisor -->
            <div class="planDivider"></div>

            <!-- Dados da Empresa -->
            <div class="planDataSection">
              <h3 class="planDataTitle">Dados da Empresa</h3>
              <div class="planDataItems">
                <div class="planDataItem">
                  <span class="planDataLabel">Nome:</span>
                  <span class="planDataValue">BMS Softwares</span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">CNPJ:</span>
                  <span class="planDataValue">03.054.436/0001-51</span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">E-mail:</span>
                  <span class="planDataValue">sac@bmssoftwares.com.br</span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">Contato:</span>
                  <span class="planDataValue">(31) 3891-9414</span>
                </div>
              </div>
            </div>

            <!-- Divisor -->
            <div class="planDivider"></div>

            <!-- Dados do Plano -->
            <div class="planDataSection">
              <h3 class="planDataTitle">Dados do Plano</h3>
              <div class="planDataItems">
                <div class="planDataItem">
                  <span class="planDataLabel">Sistema:</span>
                  <span class="planDataValue">Winfit Agro+</span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">Plano:</span>
                  <span class="planDataValue">
                    <span v-if="objectPlan.tipoPlano === 'tester'">Tester</span>
                    <span v-else-if="objectPlan.tipoPlano === 'gestao_simples'"
                      >Gestão Simples</span
                    >
                    <span v-else-if="objectPlan.tipoPlano === 'gestao_completo'"
                      >Gestão Completo</span
                    >
                    <span
                      v-else-if="
                        objectPlan.tipoPlano === 'gestao_personalizado'
                      "
                      >Gestão Personalizado</span
                    >
                  </span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">Emissão Fiscal:</span>
                  <span class="planDataValue">
                    <span v-if="objectPlan.tipoPlano === 'gestao_simples'"
                      >Desabilitada</span
                    >
                    <span v-else>Habilitada</span>
                  </span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">Acessos/Responsáveis:</span>
                  <span class="planDataValue">Até 5 acessos</span>
                </div>
                <div class="planDataItem">
                  <span class="planDataLabel">Período de vigência:</span>
                  <span class="planDataValue">
                    <span v-if="objectPlan.dataInicio && objectPlan.dataFim">
                      {{ formatDate(objectPlan.dataInicio) }} a
                      {{ formatDate(objectPlan.dataFim) }}
                    </span>
                    <span v-else-if="objectPlan.dataFim">
                      Válido até {{ formatDate(objectPlan.dataFim) }}
                    </span>
                    <span v-else>Ativo</span>
                  </span>
                </div>
                <div v-if="objectPlan.assinatura" class="planDataItem">
                  <span class="planDataLabel">Assinatura Digital:</span>
                  <span class="planDataValue">{{
                    objectPlan.assinatura === true
                      ? "Habilitada"
                      : "Desabilitada"
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="planSupportButtonRow">
            <button class="planSupportButton" @click="redirectWhatsApp">
              Falar com Suporte
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modalInfo"
      size="md"
      hide-footer
      hide-header
      centered
      title="Info"
    >
      <div @click="$bvModal.hide('modalInfo')" class="closeModal">
        <b-icon-x scale="1.3"></b-icon-x>
      </div>

      <Tabs :tabs="tabs" :tabSelected="tabSelected">
        <template v-slot:videos>
          <div class="containerYt">
            <div class="contentYt">
              <span
                style="font-weight: bold; font-size: 13px; font-style: oblique"
                >Últimos Videos:</span
              >
              <div
                class="itemYt"
                onclick="window.open('https://www.youtube.com/watch?v=CkR45_IA8ZI&t=1s', '_blank');"
              >
                <div class="contentLogoYt">
                  <img class="imgYt" loading="lazy" :src="YtLogo" />
                </div>
                <div class="descriptionYt">
                  <span style="font-weight: bold; font-size: 13px"
                    >Apresentação</span
                  >
                  <span
                    style="
                      font-weight: bold;
                      font-size: 11px;
                      color: gray;
                      font-style: oblique;
                    "
                    >Clique aqui para assistir nosso video de
                    Apresentação.</span
                  >
                </div>
              </div>
              <div
                class="itemYt"
                onclick="window.open('https://www.youtube.com/watch?v=63LIDvPf51w', '_blank');"
              >
                <div class="contentLogoYt">
                  <img class="imgYt" loading="lazy" :src="YtLogo" />
                </div>
                <div class="descriptionYt">
                  <span style="font-weight: bold; font-size: 13px"
                    >Frente de Caixa</span
                  >
                  <span
                    style="
                      font-weight: bold;
                      font-size: 11px;
                      color: gray;
                      font-style: oblique;
                    "
                    >Clique aqui para assistir a demonstração do frente de caixa
                    e emissão de NFC-e.</span
                  >
                </div>
              </div>
              <div
                class="itemYt"
                onclick="window.open('https://www.youtube.com/watch?v=5Q-HSBrj18g', '_blank');"
              >
                <div class="contentLogoYt">
                  <img class="imgYt" loading="lazy" :src="YtLogo" />
                </div>
                <div class="descriptionYt">
                  <span style="font-weight: bold; font-size: 13px">Vendas</span>
                  <span
                    style="
                      font-weight: bold;
                      font-size: 11px;
                      color: gray;
                      font-style: oblique;
                    "
                    >Clique aqui para assistir a demonstração da tela de vendas
                    e emissão de NF-e.</span
                  >
                </div>
              </div>
              <div
                class="itemYt"
                onclick="window.open('https://www.youtube.com/watch?v=iL7Re2hSgCA', '_blank');"
              >
                <div class="contentLogoYt">
                  <img class="imgYt" loading="lazy" :src="YtLogo" />
                </div>
                <div class="descriptionYt">
                  <span style="font-weight: bold; font-size: 13px"
                    >Orçamentos</span
                  >
                  <span
                    style="
                      font-weight: bold;
                      font-size: 11px;
                      color: gray;
                      font-style: oblique;
                    "
                    >Clique aqui para assistir a demonstração da tela de
                    Orçamentos.</span
                  >
                </div>
              </div>
              <div class="socialMedia">
                <div class="descriptionsocialMedia">
                  <span
                    style="
                      font-weight: bold;
                      font-size: 11px;
                      color: gray;
                      font-style: oblique;
                    "
                    >Siga Nossas Redes Sociais</span
                  >
                </div>
                <div class="contentLogosocialMedia">
                  <img
                    onclick="window.open('https://www.youtube.com/@BmsSoftwares/', '_blank');"
                    style="
                      width: 55px;
                      height: 40px;
                      padding: 10px;
                      cursor: pointer;
                    "
                    loading="lazy"
                    :src="YtLogo"
                  />
                  <img
                    onclick="window.open('https://www.instagram.com/bms_gestao/', '_blank');"
                    style="
                      width: 50px;
                      height: 50px;
                      padding: 10px;
                      cursor: pointer;
                    "
                    loading="lazy"
                    :src="Instagram"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:tributario>
          <b-card class="scrollTrib"> </b-card>
        </template>
      </Tabs>
    </b-modal>
    <div
      class="mobile-overlay"
      :class="{ open: !collapsedMobile }"
      @click="closeMobileSidebar"
    ></div>
    <div class="mobile-wrapper">
      <button class="toggle-btn-mobile" @click="sidBarMobileExpand">
        <b-icon-list-nested
          v-if="collapsedMobile"
          scale="1.4"
          variant="light"
        />
        <b-icon-x v-else scale="1.4" variant="light" />
      </button>

      <div class="sidebar-content-mobile" :class="{ open: !collapsedMobile }">
        <div class="sidebar-header-mobile">
          <img :src="logoBms" alt="Logo" class="logo" />
          <span class="title">Winfit Agro+</span>
        </div>
        <ul class="nav-linksApp">
          <li>
            <router-link to="/mobile">
              <button
                class="contentLinkApp"
                :class="{ activeNavItems: navItemSelected === 'mobile' }"
                @click="closeMobileSidebar"
              >
                <i> <b-icon-house-fill scale="1.3" /></i>
                <span class="link_nameApp">Início</span>
              </button>
            </router-link>
          </li>
          <li>
            <router-link to="/estoque-mobile">
              <button
                class="contentLinkApp"
                :class="{
                  activeNavItems: navItemSelected === 'estoque-mobile',
                }"
                @click="closeMobileSidebar"
              >
                <i>
                  <b-icon-file-earmark-diff
                    scale="1.3"
                  ></b-icon-file-earmark-diff
                ></i>
                <span class="link_nameApp">Estoque</span>
              </button>
            </router-link>
          </li>
          <li>
            <router-link to="/app/compendio">
              <button
                class="contentLinkApp"
                :class="{ activeNavItems: navItemSelected === 'app-compendio' }"
                @click="closeMobileSidebar"
              >
                <i><img style="height: 35px; width: 35px" :src="leaf" /></i>
                <span class="link_nameApp">Compêndio</span>
              </button>
            </router-link>
          </li>
          <li>
            <router-link to="/mobile-cadastros">
              <button
                class="contentLinkApp"
                :class="{
                  activeNavItems: navItemSelected === 'mobile-cadastros',
                }"
                @click="closeMobileSidebar"
              >
                <i>
                  <b-icon-person-lines-fill scale="1.3" />
                </i>
                <span class="link_nameApp">Cadastros</span>
              </button>
            </router-link>
          </li>
          <li>
            <router-link to="/receita-mobile">
              <button
                class="contentLinkApp"
                :class="{
                  activeNavItems: navItemSelected === 'receita-mobile',
                }"
                @click="closeMobileSidebar"
              >
                <i> <b-icon-journal-text scale="1.3"></b-icon-journal-text></i>
                <span class="link_nameApp">Receituário</span>
              </button>
            </router-link>
          </li>

          <li :class="!winfitComleto ? 'disabledLink' : ''">
            <router-link :to="winfitComleto ? '/compras-mobile' : ''">
              <button
                class="contentLinkApp"
                :class="{
                  activeNavItems: navItemSelected === 'compras-mobile',
                }"
                @click="closeMobileSidebar"
              >
                <i> <b-icon-cart4 scale="1.3"></b-icon-cart4></i>
                <span class="link_nameApp">Compras</span>
              </button>
            </router-link>
          </li>
          <li :class="!winfitCompletePlan ? 'disabledLink' : ''">
            <router-link :to="winfitCompletePlan ? '/cheques' : ''">
              <button
                class="contentLinkApp"
                :class="{ activeNavItems: navItemSelected === 'cheques' }"
                @click="closeMobileSidebar"
              >
                <i><b-icon-credit-card2-front scale="1.3" /></i>
                <span class="link_nameApp">Cheques</span>
              </button>
            </router-link>
          </li>
          <li>
            <router-link to="/configuracoes-mobile">
              <button
                class="contentLinkApp"
                :class="{
                  activeNavItems: navItemSelected === 'configuracoes-mobile',
                }"
                @click="closeMobileSidebar"
              >
                <i> <b-icon-gear scale="1.3"></b-icon-gear></i>
                <span class="link_nameApp">Configurações</span>
              </button>
            </router-link>
          </li>
        </ul>
        <div class="sidebar-footer-mobile">
          <li>
            <router-link to="/">
              <button @click="exit" class="contentLinkApp exitBtn">
                <i> <b-icon-door-open scale="1.3"></b-icon-door-open></i>
                <span class="link_nameApp">Sair</span>
              </button>
            </router-link>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import logoBms from "../../assets/Logo-Sem-Fundo-WINFIT-AGRO.png";
import { clearTokens } from "../../utils/clearTokens";
import serviceUser from "../../services/serviceUser";
import planBlack from "../../assets/planBlack.png";
import winfitLogoAgro from "../../assets/Logo-Sem-Fundo-WINFIT-AGRO.png";
import YtLogo from "../../assets/YtLogo.png";
import Instagram from "../../assets/Instagram.png";
import gear from "../../assets/gear.svg";
import pdv2 from "../../assets/pdv2.svg";
import sales from "../../assets/sales.svg";
import leaf from "../../assets/leaf.svg";
import faarm from "../../assets/faarm.svg";
import exclusive from "../../assets/lock.svg";
import receipt from "../../assets/receipt.svg";
import api from "../../services/axios";
import Tabs from "../UI/Tabs/Tab.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";

export default {
  components: {
    Tabs,
    InputSelect,
  },
  data() {
    return {
      logoBms: logoBms,
      planBlack: planBlack,
      winfitLogoAgro: winfitLogoAgro,
      leaf: leaf,
      faarm: faarm,
      exclusive: exclusive,
      gear: gear,
      pdv2: pdv2,
      sales: sales,
      receipt: receipt,
      YtLogo: YtLogo,
      Instagram: Instagram,
      colapse: true,
      collapsed: true,
      collapsedMobile: true,
      spinGeneral: false,
      disable: "",
      alternClassMobile: "disableMobile",
      sizeText: "link_name",
      iconsCenter: "btnsGerais",
      btnSair: "btnSair",
      sideOCompany: "sideCompanyDisable",
      contentSideOCompany: "disabledContent",
      companies: [],
      tokenCompanySelected: null,
      user: {},
      isSideCommonOpen: false,
      objectPlan: {},
      tabSelected: 0,
      tabs: [
        { name: "videos", text: "Videos" },
        { name: "tributario", text: "Guia tributário" },
      ],
      pdfLink:
        "https://contratos-gerais.s3.sa-east-1.amazonaws.com/contratoWinfit.pdf",
      consultationIsChecked: false,
      expandOrder: false,
      expandFinancialManagement: false,
      winfitComleto: false,
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    handleCompanySelected() {
      localStorage.setItem("token", this.tokenCompanySelected);
      window.location.reload();
    },
    openContract() {
      window.open(this.pdfLink, "_blank");
    },
    sidBarExpand() {
      this.disable = this.disable !== "disable" ? "disable" : "";
      this.colapse = !this.colapse;
      this.sizeText = this.colapse ? "link_name" : "link_nameTwo";
      this.iconsCenter = this.colapse ? "btnsGerais" : "btnsGeraisTwo";
      this.btnSair = this.colapse ? "btnSair" : "btnSairTwo";
      if (this.colapse) this.$store.commit("REGISTER_WIDTH", "80%");
      else this.$store.commit("REGISTER_WIDTH", "90%");

      this.$nextTick(() => {
        if (this.disable) {
          this.consultationIsChecked = false;
        } else if (this.navItemSelected === "consultas" && !this.disable) {
          this.consultationIsChecked = true;
        }
      });
    },
    sidBarMobileExpand() {
      this.collapsedMobile = !this.collapsedMobile;

      // Controlar scroll da página
      if (!this.collapsedMobile) {
        // Sidebar aberta - bloquear scroll
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      } else {
        // Sidebar fechada - permitir scroll
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
      }
    },

    closeMobileSidebar() {
      if (!this.collapsedMobile) {
        this.collapsedMobile = true;
        // Restaurar scroll da página
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
      }
    },
    sideOpenCompany() {
      this.collapsed = !this.collapsed;
      this.sideOCompany = this.collapsed ? "sideCompany" : "sideCompanyDisable";
      this.contentSideOCompany = this.collapsed ? "" : "disabledContent";
      this.isSideCommonOpen = !this.isSideCommonOpen;
    },

    handleClickOutside(event) {
      const sideCommonElement = this.$el.querySelector(".sideCompany");

      if (
        sideCommonElement &&
        !sideCommonElement.contains(event.target) &&
        !event.target.classList.contains("buttonToOpenSideCommon")
      ) {
        this.isSideCommonOpen = false;
        this.collapsed = false;
        this.sideOCompany = "sideCompanyDisable";
        this.contentSideOCompany = "";
      }
    },

    sideOpenAdnFindUser() {
      this.sideOpenCompany();
      this.handleFindUser();
    },
    exit() {
      clearTokens();
    },
    redirectWhatsApp() {
      const phoneNumber = "3138919414";
      const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\D/g, "")}`;
      window.open(whatsappUrl, "_blank");
    },
    redirectNewPlanWhatsApp() {
      const serviceMessage = encodeURIComponent(
        "Olá , tenho interesse em trocar meu plano no Gestão Web!"
      );
      const phoneNumber = "3138919414";

      const url = `https://wa.me/${phoneNumber}?text=${serviceMessage}`;
      window.open(url, "_blank");
    },

    async findPlan() {
      const data = await api.get("/plans/verify");
      this.objectPlan = data.data;
    },

    async handleFindUser() {
      try {
        this.spinGeneral = true;
        this.user = await serviceUser.findUnserInGestao();
      } catch (error) {
        console.log(error);
      } finally {
        this.spinGeneral = false;
      }
    },

    handleTokenList() {
      const tokens = JSON.parse(localStorage.getItem("tokenList"));
      const token = localStorage.getItem("token");
      if (tokens && tokens.length) {
        this.companies = tokens;

        const companySelected = tokens.find((item) => item.token === token);
        this.tokenCompanySelected = companySelected.token;

        this.$nextTick(() => {
          if (this.$refs.companies)
            this.$refs.companies.valueItems = companySelected.token;
        });
      }
    },

    parseIntegrations(integrations) {
      if (typeof integrations !== "string") return integrations;

      try {
        return JSON.parse(integrations);
      } catch {
        return null;
      }
    },

    redirectToConsultations() {
      if (this.navItemSelected !== "consultas") {
        this.$router.push({ path: "/consultas" });
      }

      this.consultationIsChecked = true;
    },
    handleVerifyUserCorporation() {
      const userLevel = localStorage.getItem("userLevel");
      if (userLevel === "corporate") {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    ...mapState([
      "navItemSelected",
      "dataCompany",
      "numberOfNewMessages",
      "dataPlan",
      "enableMtq",
    ]),
    winfitCompletePlan() {
      const tipoPlano = this.dataPlan?.tipoPlano || localStorage.getItem("plan");
      return tipoPlano === "gestao_completo";
    },
    handleVerifyUserIsAccountant() {
      const userLevel = localStorage.getItem("userLevel");
      if (userLevel === "accountant") {
        return true;
      } else {
        return false;
      }
    },

    enableSelectCompany() {
      const tokens = localStorage.getItem("tokenList");
      if (tokens && tokens.length) {
        return true;
      } else {
        return false;
      }
    },

    allowsBoleto() {
      const integrations = this.parseIntegrations(
        this.dataCompany?.liberars?.[0]?.integracoes
      );
      const boletos = integrations?.boletos || [];

      return Boolean(
        boletos.find((boleto) => boleto.text?.toUpperCase() === "SICOOB")?.value
      );
    },
  },
  created() {
    this.sidBarExpand();
    this.handleTokenList();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);

    this.winfitComleto = localStorage.getItem("winfitCompleto") === "true";
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    // Limpar styles do body ao destruir componente
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: sans-serif;
}

@import url("https://fonts.googleapis.com/css?family=Poppins:500,500,500");

.sidebar {
  position: fixed !important;
  z-index: 1000;
  top: 50px;
  height: 100vh;
  max-height: calc(100vh - 50px);
  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #006256;
  transition: all 0.5s ease;
  /* overflow-y: overlay;
  overflow-x: hidden; */
}

.activeSubNavItems {
  border-left: solid 2px #768593 !important;
}

.prescription:hover {
  border-radius: 5px !important;
}

.prescription span {
  font-size: 11.5px !important;
}

.disable {
  position: fixed !important;
  z-index: 1000;
  top: 50px;
  height: calc(100vh - 50px);
  width: 60px;
  background: #006256;
  transition: all 0.5s ease;
}

.disableMobile {
  display: none;
}

.sideMobile {
  display: none;
}

.sidebarMobile {
  display: none;
}

.nav-links {
  overflow-y: auto;
  overflow-x: hidden;
}

.nav-links::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

.nav-links::-webkit-scrollbar-track {
  background: #006256;
}

.nav-links::-webkit-scrollbar-thumb {
  background-color: #709e8a;
  border-radius: 0;
}

.sidebar .nav-links li {
  height: 40px;
  width: 100%;
  list-style: none;
}

.sidebar .nav-links li .contentLink:disabled {
  color: red;
}

.sidebar .nav-links li .contentLink {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
}

.sidebar .nav-links li .contentLink:hover {
  background: #709e8a;
}

.sidebar .nav-links li .contentLink i {
  min-width: 55px;
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.sidebar .nav-links li .contentLink .link_name {
  color: #fff;
  font-size: 13px;
  width: 100%;
  transition: all 0.4s ease;
  overflow: hidden;
  text-align: start;
}

.sidebar .nav-links li .contentLink .link_nameTwo {
  color: #fff;
  font-size: 0px;
  display: none;
  transition: all 0.4s ease;
  overflow: hidden;
}

.sidebar .nav-links li .contentLink .droperText {
  color: #fff;
  font-size: 12px;
  transition: all 0.4s ease;
}

li a {
  margin-top: 5px;
  text-decoration: none !important;
}

ul {
  margin-bottom: 0 !important;
}

#logoEmpresaTwo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 4px solid white;
  object-fit: contain;
  transition: all 0.4s ease;
}

.nomeEmpresaText {
  font-size: 28px;
  transition: all 0.4s ease;
}

.nomeEmpresaTextTwo {
  font-size: 0px;
  transition: all 0.4s ease;
}

.containerBtnSair {
  /* position: absolute;
  bottom: 10px; */
  width: 100%;
}

.btnSair {
  bottom: 0;
  color: white;
  font-size: 14px;
  transition: all 0.4s ease;
}

.btnSairTwo {
  display: none;
  bottom: 0;
  color: white;
  font-size: 0px;
  transition: all 0.4s ease;
}

#inputConsultations {
  display: none;
}

#inputConsultations:checked + .ulConsultation {
  visibility: visible !important;
  height: 80px !important;
  transition: ease-in all 0.3s !important;
}

.ulConsultation {
  overflow: hidden;
  visibility: hidden;
  height: 0;
  transition: ease-in all 0.3s;
}

.linkAgrot:hover {
  background-color: #0bc06f2b !important;
}

span {
  cursor: pointer;
}

.iconEffect {
  display: none !important;
}

.iconEffect:focus i {
  background-color: #709e8a !important;
  transform: rotate(180deg) !important;
}

.spin {
  height: 20px;
  width: 20px;
  color: gray;
}

.userContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2px;
  text-transform: capitalize;
}

.userContent p {
  color: #1f2d2a;
  font-size: 14px;
  line-height: 1.2;
}

.teach {
  width: 21px;
  height: 21px;
}

.activeNavItems {
  background-color: #709e8a !important;
}

.activeConsultationsNavItems {
  border-left: solid 2px #709e8a !important;
}

.activeConsultationsNavItems:hover {
  background-color: transparent !important;
}

.btnsGeraisTwo {
  justify-content: center !important;
  outline: none !important;
  border: none;
  color: white;
}

.btnsGerais {
  outline: none !important;
  border: none;
}

button {
  background-color: transparent;
  padding: 5px;
}

.navBar {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 50px;
  background-color: white;
  color: #006256 !important;
  display: flex;
  align-items: center;
  padding: 0 16px 0 5px;
  box-shadow: 0px 0px 5px 0px rgb(106, 102, 102);
}

.contentLogoAndTitle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 80px;
  font-size: 22px;
}

.contentHelp {
  position: relative;
  background-color: #ffffff;
  padding: 2px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  z-index: 2;
}

.contentHelp:hover {
  background-color: #d7d7d7;
}

.contentHelp div {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.iconHelper {
  width: 35px;
  height: 35px;
  color: #313b42;
  z-index: 1000;
  padding: 7px;
}

.sideCompany {
  display: flex;
  position: absolute;
  width: 300px;
  max-width: calc(100vw - 20px);
  min-height: 380px;
  max-height: calc(100vh - 80px);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbfa 100%);
  right: 10px;
  top: 60px;
  border: 1px solid rgba(0, 98, 86, 0.12);
  border-radius: 14px;
  flex-direction: column;
  align-items: center;
  padding: 16px 18px 14px;
  gap: 14px;
  box-shadow: 0 18px 36px -24px rgba(0, 46, 40, 0.7),
    0 10px 20px -16px rgba(0, 98, 86, 0.55);
  overflow: hidden;
}

.sideCommon {
  transition: all 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

.sideCompanyDisable {
  height: 0;
  visibility: hidden;
  display: none;
}

.disabledContent {
  height: 0;
  visibility: hidden;
  /* animation: example 3s; */
}

@keyframes example {
  from {
    visibility: hidden;
  }
  to {
    visibility: visible;
  }
}

.closeSize {
  color: #7b8d89;
  display: flex;
  width: 28px;
  height: 28px;
  border: 1px solid rgba(0, 98, 86, 0.15);
  background-color: #ffffff;
  border-radius: 50%;
  font-size: 14px;
  position: absolute;
  left: 12px;
  top: 10px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.closeSize:hover {
  background-color: #eaf4f1;
  color: #006256;
}

.logoSide {
  width: 78px;
  height: 78px;
  border: 2px solid rgba(0, 98, 86, 0.18);
  box-shadow: 0 8px 15px -12px rgba(0, 98, 86, 0.55);
  object-fit: cover;
  border-radius: 50%;
}

.btnModal-contract {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentPlan {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
  padding: 5px 20px;
}

.contentContract {
  height: 85vh;
  position: relative;
}

.titleContract {
  font-size: 23px;
  text-align: center;
}

.textContract {
  text-align: justify;
  font-size: 12px;
  height: 70vh;
  max-height: 70vh;
  overflow: auto;
  padding: 0 50px;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgba(238, 238, 238, 0);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0);
}

.contentContractPlan {
  height: 60vh;
}

/* ===== Novo Estilo Modal Meu Plano ===== */
.planModalContainer {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  max-height: none;
  overflow: visible;
}

.planCardMain {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.planLogoRow {
  display: flex;
  justify-content: flex-end;
  padding: 4px 14px 0 14px;
}

.winfitLogo {
  width: 165px;
  height: auto;
  object-fit: contain;
  display: block;
}

.planCardContent {
  padding: 6px 20px 14px 20px;
}

.planDataSection {
  margin-bottom: 20px;
}

.planDataSection:last-of-type {
  margin-bottom: 0;
}

.planDataTitle {
  font-size: 14px;
  font-weight: 700;
  color: #006256;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.planDataItems {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.planDataItem {
  display: flex;
  gap: 8px;
  font-size: 13px;
  align-items: flex-start;
}

.planDataLabel {
  font-weight: 600;
  color: #555;
  min-width: 140px;
}

.planDataValue {
  color: #777;
  flex: 1;
}

.planDivider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #d0d0d0, transparent);
  margin: 15px 0;
}

.planSupportButtonRow {
  display: flex;
  justify-content: center;
  padding: 16px 20px 20px 20px;
}

.planSupportButton {
  width: 100%;
  max-width: 360px;
  min-height: 46px;
  padding: 12px 20px;
  background: #006256;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin: 0;
}

.planSupportButton:hover {
  background: #005249;
  transform: translateY(-1px);
}

.planSupportButton:active {
  transform: translateY(0);
}

/* Scroll customizado para o modal */
.planModalContainer::-webkit-scrollbar {
  width: 6px;
}

.planModalContainer::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.planModalContainer::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.planModalContainer::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Responsividade Mobile */
@media screen and (max-width: 600px) {
  .planLogoRow {
    padding: 4px 10px 0 10px;
  }

  .winfitLogo {
    width: 130px;
  }

  .planCardContent {
    padding: 6px 14px 12px 14px;
  }

  .planDataItem {
    flex-direction: column;
    gap: 4px;
  }

  .planDataLabel {
    min-width: auto;
    font-size: 12px;
  }

  .planDataValue {
    font-size: 12px;
  }

  .planSupportButtonRow {
    padding: 12px 14px 14px 14px;
  }

  .planSupportButton {
    width: 100%;
    max-width: none;
    min-height: 44px;
    padding: 10px 15px;
    font-size: 12px;
  }
}

/* ===== Estilos Antigos (mantidos para compatibilidade) ===== */

.bodyPlan {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 5px;
}

/* Estilos antigos removidos - modal redesenhado */

.headerSide {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 22px 0 12px;
  gap: 8px;
  border-bottom: 1px solid #d9e7e3;
}

.headerSide > p {
  color: #006256;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.contentSide {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.contentSideDown {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  bottom: 10px;
  gap: 5px;
}

.contentSideBtn {
  border: 1px solid #d8e5e2;
  background: #f6f9f8;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #294049;
  padding: 10px 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.contentSideBtn:hover {
  background: #eaf5f2;
  border-color: #bdd9d2;
  transform: translateY(-1px);
  color: #294049;
}

.btnExitIsAccountant {
  color: white;
  padding: 7px;
  background-color: rgb(62, 102, 174);
  width: 70px;
  border-radius: 5px;
  text-align: center;
  letter-spacing: 0.1rem;
  transition: ease-in all 0.1s;
  font-weight: 500 !important;
}

.btnExitIsAccountant:hover {
  background-color: rgb(52, 85, 145);
  transition: ease-in all 0.1s;
}

.nameCompanyCompanies {
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  gap: 5px;
  font-size: 16px;
  width: 25%;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}
.nameCompany {
  color: gray;
  font-size: 16px;
}

.nameCompany span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.contentSelectCompany {
  width: 25%;
  color: white;
  font-size: 16px;
}

.contentSelectCompany span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.textAccountant {
  color: #313b42;
  font-size: 18px;
}

.textAccountant span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.contentHelpAndNotificationAccounting {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.contentHelpAndNotificationAccounting a {
  text-decoration: none;
  outline: none;
  color: #313b42;
}

.contentHelpAndNotificationAccounting a:hover {
  text-decoration: none;
  outline: none;
  color: black;
}

.contentNotificationAccounting {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  background-color: #006256;
  color: whitesmoke;
  padding: 0.2rem;
  border-radius: 2px;
  text-align: center;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.contentNotificationAccounting:hover {
  background-color: #709e8a;
}

.scrollTrib {
  height: 60vh;
}

.containerYt {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contentYt {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: #f1f1f1;
  padding: 5px 10px 0 10px;
}

.disabledLink {
  user-select: none;
  pointer-events: none;
  opacity: 0.3;
}

.itemYt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  height: 80px;
  gap: 20px;
  border: 1px solid rgb(227, 227, 227);
  border-radius: 8px;
}

.imgYt {
  width: 45px;
  height: 25px;
}

.descriptionYt {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contentLogosocialMedia {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.socialMedia {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.numberMessages {
  width: 18px;
  height: 18px;
  position: absolute;
  top: -4px;
  right: -5px;
  background-color: red;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.357);
}

p {
  margin: 0 !important;
}

.warningExpiredPlan {
  position: absolute;
  top: -7px;
  right: -3px;
}

.contentBtnMyPlan {
  position: relative;
  color: #ffffff;
  background: linear-gradient(135deg, #006256 0%, #0a7f70 100%);
  border-color: transparent;
  box-shadow: 0 10px 20px -14px rgba(0, 98, 86, 0.8);
}

.warningExpiredPlanToModal {
  position: absolute;
  right: 14px;
  display: inline-flex;
  align-items: center;
}

.containerMobile {
  display: none;
}

.mobile-wrapper {
  display: none;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .sidebar .nav-links li {
    height: 35px;
  }

  .sidebar {
    justify-content: start;
  }

  .disable {
    width: 50px;
  }

  .contentLogoAndTitle {
    gap: 30px;
    font-size: 20px;
  }

  .nameCompany {
    font-size: 14px;
  }

  .contentNotificationAccounting {
    font-size: 11px;
  }

  .contentHelpAndNotificationAccounting {
    gap: 1rem;
  }

  .contentHelp {
    padding: 0px;
  }
}

@media screen and (max-width: 900px) {
  .mobile-wrapper {
    display: flex;
    align-items: flex-start;
    position: fixed;
    top: 0px;
    right: 0;
    z-index: 1000;
    height: auto;
    pointer-events: none;
  }

  .mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(9, 24, 21, 0.48);
    backdrop-filter: blur(5px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 499;
  }

  .mobile-overlay.open {
    opacity: 1;
    visibility: visible;
  }

  /* Prevenir scroll quando sidebar estiver aberta */
  body.no-scroll {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100% !important;
  }

  .toggle-btn-mobile {
    background: rgba(0, 98, 86, 0.92);
    border: 1px solid rgba(255, 255, 255, 0.32);
    border-radius: 14px 0 0 14px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    color: white;
    box-shadow: 0 12px 28px rgba(0, 58, 51, 0.28);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    pointer-events: auto;
  }

  .toggle-btn-mobile:hover {
    background: #007767;
    transform: translateX(-1px);
    box-shadow: 0 12px 24px rgba(0, 98, 86, 0.32);
  }

  .toggle-btn-mobile:active {
    transform: translateX(0);
    box-shadow: 0 2px 8px rgba(0, 98, 86, 0.3);
  }

  .sidebar-content-mobile {
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.98),
        rgba(245, 251, 249, 0.98)
      ),
      #f5fbf9;
    height: 100dvh;
    max-height: 100dvh;
    width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    display: flex;
    flex-direction: column;
    box-shadow: -18px 0 44px rgba(3, 24, 21, 0.24);
    border-radius: 0px 0 0 24px;
    border-left: 1px solid rgba(255, 255, 255, 0.78);
    pointer-events: auto;
  }

  .sidebar-content-mobile.open {
    width: min(74vw, 320px);
    box-shadow: -22px 0 54px rgba(3, 24, 21, 0.28);
  }

  .sidebar-header-mobile {
    background: linear-gradient(135deg, #006256 0%, #008575 100%);
    padding: 18px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 12px 12px 10px;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 18px;
    box-shadow: 0 14px 28px rgba(0, 98, 86, 0.22);
    overflow: hidden;
    position: relative;
  }

  .sidebar-header-mobile::after {
    content: "";
    position: absolute;
    right: -28px;
    top: -32px;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    border: 22px solid rgba(255, 255, 255, 0.08);
  }

  .sidebar-header-mobile .logo {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.32);
    background: #ffffff;
    box-shadow: 0 8px 18px rgba(0, 36, 31, 0.2);
    z-index: 1;
  }

  .sidebar-header-mobile .title {
    color: #ffffff;
    font-size: 17px;
    font-weight: 800;
    letter-spacing: 0;
    z-index: 1;
    white-space: nowrap;
  }

  .nav-linksApp {
    padding: 4px 12px 0;
    margin: 0;
    list-style: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .nav-linksApp li {
    width: 100%;
  }

  .nav-linksApp li:last-child {
    margin-top: auto;
    margin-bottom: 16px;
  }

  .contentLinkApp {
    background: transparent;
    border: none;
    border-radius: 14px;
    width: 100%;
    min-height: 46px;
    padding: 7px 9px;
    display: flex;
    align-items: center;
    gap: 11px;
    cursor: pointer;
    text-align: left;
    white-space: nowrap;
    transition: background-color 0.2s ease, box-shadow 0.2s ease,
      transform 0.2s ease;
    margin-bottom: 2px;
    position: relative;
    overflow: hidden;
  }

  .contentLinkApp:hover {
    background: rgba(0, 98, 86, 0.07);
    transform: translateX(2px);
  }

  .contentLinkApp.activeNavItems {
    background: #ffffff;
    box-shadow: 0 12px 26px rgba(0, 98, 86, 0.14);
    transform: none;
    border: 1px solid rgba(0, 98, 86, 0.14);
  }

  .contentLinkApp.activeNavItems::after {
    content: "";
    position: absolute;
    left: 0;
    top: 11px;
    bottom: 11px;
    width: 4px;
    border-radius: 0 8px 8px 0;
    background: #006256;
  }

  .contentLinkApp.activeNavItems .link_nameApp {
    font-weight: 800;
    color: #006256;
  }

  .link_nameApp {
    font-size: 14px;
    color: #475753;
    letter-spacing: 0;
    font-weight: 750;
    transition: color 0.2s ease;
  }

  .contentLinkApp i {
    min-width: 32px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: rgba(0, 98, 86, 0.09);
    color: #006256;
    transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
  }

  .contentLinkApp:hover i {
    background: rgba(0, 98, 86, 0.13);
    transform: scale(1.04);
  }

  .contentLinkApp.activeNavItems i {
    background: #006256;
    color: #ffffff;
    box-shadow: 0 8px 16px rgba(0, 98, 86, 0.22);
  }

  .contentLinkApp i img {
    width: 23px !important;
    height: 23px !important;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(29%) sepia(51%) saturate(967%)
      hue-rotate(130deg) brightness(85%) contrast(95%);
  }

  .contentLinkApp.activeNavItems i img {
    filter: brightness(0) invert(1);
  }

  .sidebar-content-mobile::-webkit-scrollbar {
    width: 4px;
  }

  .sidebar-content-mobile::-webkit-scrollbar-track {
    background: rgba(112, 158, 138, 0.1);
    border-radius: 2px;
  }

  .sidebar-content-mobile::-webkit-scrollbar-thumb {
    background: rgba(0, 98, 86, 0.3);
    border-radius: 2px;
  }

  .sidebar-content-mobile::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 98, 86, 0.5);
  }

  .sidebar-footer-mobile {
    position: sticky;
    bottom: 0;
    margin-top: auto;
    padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid rgba(0, 98, 86, 0.08);
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(12px);
    z-index: 2;
  }

  .exitBtn {
    background: linear-gradient(135deg, #dc2f45, #c82438) !important;
    color: white !important;
    border: none !important;
    min-height: 48px;
    box-shadow: 0 8px 18px rgba(220, 47, 69, 0.22);
    border-radius: 14px;
  }

  .exitBtn:hover {
    background: #c92538 !important;
    transform: translateX(2px) !important;
    box-shadow: 0 10px 20px rgba(220, 47, 69, 0.26) !important;
  }

  .exitBtn .link_nameApp {
    color: white !important;
    font-weight: 600;
  }

  .exitBtn i {
    background: rgba(255, 255, 255, 0.18) !important;
    color: white !important;
  }

  .exitBtn:hover i {
    background: rgba(255, 255, 255, 0.3) !important;
  }

  @media screen and (max-height: 760px) {
    .sidebar-header-mobile {
      margin: 10px 10px 8px;
      padding: 14px;
    }

    .contentLinkApp {
      min-height: 42px;
      padding: 5px 8px;
    }

    .contentLinkApp i {
      min-width: 30px;
      width: 30px;
      height: 30px;
    }

    .link_nameApp {
      font-size: 13px;
    }

    .sidebar-footer-mobile {
      padding-top: 8px;
    }

    .exitBtn {
      min-height: 44px;
    }
  }

  .contentLogoAndTitle {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 15px;
    justify-content: flex-start;
  }
  .logoSideApp {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .nameCompany {
    color: #006256;
    font-size: 14px;
  }

  .nameCompany span {
    font-family: Poppins-Regular, sans-serif !important;
    font-weight: 600;
  }
  .navBarApp {
    position: fixed;
    z-index: 1000;
    right: 0px;
    height: 40px;
    background-color: #4286f400;
    color: #ffffff !important;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
  .navBar {
    display: none;
  }

  .sidebar {
    display: none;
  }
}
</style>
